/**
 * Champions Dashboard - Launch Preparation Page
 * Lake Charles Landing Page - Modern Migration
 *
 * Route: /champions/dashboard/launch
 */
import React from 'react';
import { ChampionsDashboardLayout } from '../../components/champions/dashboard/ChampionsDashboardLayout';
import { LaunchPreparation } from '../../components/champions/dashboard/LaunchPreparation';

export function ChampionsLaunchPage() {
  // TODO: Replace with actual Champion data from backend/store
  const championName = 'Sarah Johnson';
  const championNumber = 3;

  return (
    <ChampionsDashboardLayout championName={championName} championNumber={championNumber}>
      <LaunchPreparation />
    </ChampionsDashboardLayout>
  );
}

export default ChampionsLaunchPage;
